import classNames from 'classnames'
import * as React from 'react'
import { Line as RechartsLine } from 'recharts'

enum LineColor {
  neutral,
  red,
  green,
}

type LineColorType = keyof typeof LineColor

interface LineProps extends React.PropsWithoutRef<React.ComponentProps<typeof RechartsLine>> {
  color?: LineColorType
}

export class Line extends React.Component<LineProps> {
  static getComposedData = RechartsLine.getComposedData
  static displayName = RechartsLine.displayName

  static defaultProps = {
    ...RechartsLine.defaultProps,
    color: 'neutral',
    dot: false,
    activeDot: false,
    isAnimationActive: false,
    connectNulls: false,
    stroke: null,
  }

  render() {
    const { color, ...props } = this.props
    const lineColor = LineColor[color as LineColorType]

    return (
      <RechartsLine
        {...props}
        className={classNames(props.className, {
          'stroke-blue-400': lineColor === LineColor.neutral,
          'stroke-red-400': lineColor === LineColor.red,
          'stroke-green-400': lineColor === LineColor.green,
        })}
      />
    )
  }
}
